import React, { useState } from 'react';
import Cookies from 'universal-cookie';
import cx from 'classnames';
import { Modal } from './../Modal';
import { ModalClose } from './../ModalClose';
import Form from './form';
import Success from './success';
import UpdateForm from './updateForm';
import auth0 from 'auth0-js';
import { useAuth0 } from '../../../context/auth0';
import authActions from '../../../action/auth';
import authOptions from '../../../define/auth';
import { invalidateUserCache } from '../../../command/userCache';
import { useDispatch } from 'react-redux';

import axios from 'axios';
import endpoints from '../../../define/endpoints';

import { BREAKPOINTS } from '../../../../constants';
import { useMatchesMinWidth } from '../../../hooks/useMatchesMinWidth';

const webAuth = new auth0.WebAuth({
  domain: process.env.REACT_APP_AUTH0_DOMAIN,
  clientID: process.env.REACT_APP_AUTH0_CLIENT_ID,
  audience: process.env.REACT_APP_AUTH0_AUDIENCE,
  scope: 'openid profile email',
  redirectUri: window.location.origin,
  responseType: 'token',
});

const cookies = new Cookies();

const ModalAffiliateContactForm = (props) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [alertMessage, setAlertMessage] = useState(false);
  const prefixesAreVisible = props.prefixesAreVisible;
  const { isAuthenticated, loginWithRedirect, user, ...auth } = useAuth0();
  const dispatch = useDispatch();

  const isDeviceSmallerThanMblLandscape = !useMatchesMinWidth(
    BREAKPOINTS.TABLET
  );
  const customerIsLogged = user && user.role === 'customer';
  const buttonClass =
    props.layout && props.layout === 'navbar'
      ? isDeviceSmallerThanMblLandscape
        ? 'beta-btn beta-btn--ghost beta-btn--s'
        : 'dropdown__navbar__item'
      : 'btn btn--primary';

  const onSubmit = ({ email, password, privacy, ...values }) => {
    setIsLoading(true);
    cookies.set('target_url', window.location.pathname, { path: '/' });
    webAuth.signupAndAuthorize(
      {
        connection: 'DB-wpdbfreedomeit',
        email,
        password,
        user_metadata: { ...values, privacy: 'true', role: 'affiliate' },
      },
      function (err, authResult) {
        if (err) {
          if (err.statusCode === 400 && err.code === 'user_exists') {
            setAlertMessage(true);
          }
          return null;
        }
        setIsLoading(false);
        setIsSuccess(true);
      }
    );
  };

  const updateData = async (values) => {
    setIsLoading(true);
    try {
      const data = {
        business_name: values.business_name,
        first_name: values.first_name,
        last_name: values.last_name,
        phone: values.phone,
        website: values.website,

        from: 'affiliate_form',
      };
      const headers = {
        Authorization: `Bearer ${auth.token}`,
      };
      axios.post(`${endpoints.core}/users/me`, data, { headers }).then(() => {
        setIsLoading(false);
        setIsSuccess(true);
        invalidateUserCache(); // Invalidate cache after success
        dispatch(authActions.init(authOptions, endpoints)); // Refresh data after success
      });
    } catch (error) {
      // console.log(error);
    }
  };

  const modal = (
    <Modal
      onClickOverlay={() => null}
      isOpen={isModalOpen}
      shouldScroll={false}
    >
      <div
        className={`modal-partner-signup ${alertMessage ? 'enable-scroll' : ''
          }`}
        style={{ width: 340 }}
      >
        <ModalClose onClick={() => setIsModalOpen(false)} />
        {isSuccess ? (
          <Success />
        ) : customerIsLogged ? (
          <UpdateForm
            user={user}
            onSubmit={updateData}
            prefixesAreVisible={prefixesAreVisible}
          />
        ) : (
          <Form
            onSubmit={onSubmit}
            prefixesAreVisible={prefixesAreVisible}
            alertMessage={alertMessage}
          />
        )}
      </div>
    </Modal>
  );

  return (
    <React.Fragment>
      {modal}
      <a onClick={() => setIsModalOpen(true)} className={buttonClass}>
        {app_main_wpml.subscribe_now}
      </a>
    </React.Fragment>
  );
};

export { ModalAffiliateContactForm };
export default ModalAffiliateContactForm;
